import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  // 首页
  {
    path: '/',
    redirect: '/tech0.1'
  },
  {
    path: '/tech0.1',
    component: () => import('../views/tech0.1')
  },
  {
    path: '/tech0.2',
    component: () => import('../views/tech0.2')
  },
  {
    path: '/tech1.1',
    component: () => import('../views/tech1.1')
  },
  {
    path: '/tech1.2',
    component: () => import('../views/tech1.2')
  },
  {
    path: '/tech2.1',
    component: () => import('../views/tech2.1')
  },
  {
    path: '/tech2.2',
    component: () => import('../views/tech2.2')
  },
  {
    path: '/tech3.1',
    component: () => import('../views/tech3.1')
  },
  {
    path: '/tech3.2',
    component: () => import('../views/tech3.2')
  },
  {
    path: '/tech3.3',
    component: () => import('../views/tech3.3')
  },
  {
    path: '/tech3.4',
    component: () => import('../views/tech3.4')
  },
  {
    path: '/tech4.1',
    component: () => import('../views/tech4.1')
  },
  {
    path: '/tech4.2',
    component: () => import('../views/tech4.2')
  },
  {
    path: '/tech5.1',
    component: () => import('../views/tech5.1')
  },
  {
    path: '/tech6.1',
    component: () => import('../views/tech6.1')
  },
  {
    path: '/tech7.1',
    component: () => import('../views/tech7.1')
  },
  {
    path: '/tech7.2',
    component: () => import('../views/tech7.2')
  },
  {
    path: '/tech8.1',
    component: () => import('../views/tech8.1')
  },
  {
    path: '/tech8.2',
    component: () => import('../views/tech8.2')
  },
  {
    path: '/tech8.3',
    component: () => import('../views/tech8.3')
  },
  {
    path: '/tech9.1',
    component: () => import('../views/tech9.1')
  },
  {
    path: '/tech9.2',
    component: () => import('../views/tech9.2')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  next()
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js